// extracted by mini-css-extract-plugin
export var bubble = "_39-0";
export var container = "_39-f";
export var contrastBorder = "_39-g";
export var greyOut = "_39-2";
export var initialsColor0 = "_39-3";
export var initialsColor1 = "_39-4";
export var initialsColor10 = "_39-d";
export var initialsColor11 = "_39-e";
export var initialsColor2 = "_39-5";
export var initialsColor3 = "_39-6";
export var initialsColor4 = "_39-7";
export var initialsColor5 = "_39-8";
export var initialsColor6 = "_39-9";
export var initialsColor7 = "_39-a";
export var initialsColor8 = "_39-b";
export var initialsColor9 = "_39-c";
export var initialsWrapper = "_39-1";
export var large = "_39-l";
export var medium = "_39-k";
export var mediumSmall = "_39-j";
export var mediumSmallMedium = "_39-o";
export var micro = "_39-h";
export var small = "_39-i";
export var tiny = "_39-n";
export var xTiny = "_39-m";